export enum TranskodeVideoProfile {
  SD = "SD",
  HDReady = "HDReady",
  HD = "HD",
  UHD = "UHD",
  TwoK = "TwoK",
  FourK = "FourK",
  EightK = "EightK",
  SixteenK = "SixteenK",
  Proxy_512x288 = "Proxy_512x288",
  Youtube_640x480 = "Youtube_640x480",
  Youtube_640x360 = "Youtube_640x360",
  Custom_800x450 = "Custom_800x450",
  PxMatch_584x800 = "PxMatch_584x800",
  PxMatch_1532x2176 = "PxMatch_1532x2176",
  PxMatch_2000x3000 = "PxMatch_2000x3000",
  PxMatch_1920_to_3840x1080_to_2160 = "PxMatch_1920_to_3840x1080_to_2160",
  PxMatch_2000_to_6000x3000_to_9000 = "PxMatch_2000_to_6000x3000_to_9000",
  PxMatch_800_to_4000x800_to_4000 = "PxMatch_800_to_4000x800_to_4000",
  PxMatch_1280_to_4000x720_to_2250 = "PxMatch_1280_to_4000x720_to_2250",
  PxMatch_800_to_4000x1200_to_6000 = "PxMatch_800_to_4000x1200_to_6000",
  PxMatch_1200_to_1920x1600_to_2560 = "PxMatch_1200_to_1920x1600_to_2560",
  Unknown = "Unknown",
  All = "All",
}
